import React from 'react';

import { CardListFilterMenuButton } from '@vlabs/monokit/entities/cards/filters/CardListFilterMenuButton';
import { useCardsFilters } from '@vlabs/monokit/entities/cards/filters/useCardsFilters';
import { CreateCardButtonPoint3 } from '@vlabs/monokit/features/create-card';
import { usePageContext } from '@vlabs/monokit/shared/ui/page';
import { useHasPermission } from '@vlabs/permissions';
import { useTranslation } from 'react-i18next';

export function ListCardsActions(): React.JSX.Element {
  const { t } = useTranslation();
  const pageCtx = usePageContext();
  const { filters } = useCardsFilters();
  const canCreateCard = useHasPermission('card', 'create');

  return (
    <React.Fragment>
      {!!canCreateCard && (
        <CreateCardButtonPoint3
          defaultValues={{
            lists: filters.list_ids,
          }}
          size={pageCtx.buttonSize}
        >
          {t('list-details-page:list_cards_actions.create_card_label')}
        </CreateCardButtonPoint3>
      )}
      <CardListFilterMenuButton exclude={['list_ids']} />
    </React.Fragment>
  );
}
